import { render } from "./PageItem.vue?vue&type=template&id=f838f5bc&scoped=true"
import script from "./PageItem.vue?vue&type=script&lang=js"
export * from "./PageItem.vue?vue&type=script&lang=js"

import "./PageItem.vue?vue&type=style&index=0&id=f838f5bc&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f838f5bc"]])

export default __exports__